import React from 'react';
import classNames from 'classnames';

import { FONT_SIZES } from '../../../constants/font.constants';

export const CardHeader = ({ 
  bold = true, className, children, size = FONT_SIZES.LG
}) => (
  <h3 className={classNames(`text-brand text-${size}`, className, {
    'font-bold': bold,
  })}>
    { children }
  </h3>
)

export default CardHeader;
